
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^8(01|89)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
